import { KycActionTypes, } from './types';
import { createAsyncAction, createAsyncMapAction } from '~lib/shared/redux/actions';
export const decideResolution = createAsyncMapAction(KycActionTypes.DECIDE_RESOLUTION, p => p.taskId);
export const getLatestKyc = createAsyncMapAction(KycActionTypes.GET_LATEST_KYC, p => p.userId);
export const getLatestKycOps = createAsyncMapAction(KycActionTypes.GET_LATEST_KYC_OPS, p => p.userId);
export const preparePhotoSubmission = createAsyncMapAction(KycActionTypes.PREPARE_PHOTO_SUBMISSION, p => p.userId);
export const submitPhotos = createAsyncAction(KycActionTypes.SUBMIT_PHOTOS);
export const revokePhotos = createAsyncAction(KycActionTypes.REVOKE_PHOTOS);
export const uploadKycDocs = createAsyncMapAction(KycActionTypes.UPLOAD_KYC_DOCS, p => p.requestId);
